import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {VoucherGenRoutingModule} from './voucher-gen-routing.module';

import {VoucherGenRepository} from './repositories/voucher-gen.repository';
import {VoucherGenService} from './services/voucher-gen.service';
import {VoucherGenComponent} from './voucher-gen.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    VoucherGenRoutingModule,
  ],
  declarations: [
    VoucherGenComponent,
  ],
  providers: [
    VoucherGenService,
    VoucherGenRepository,
  ],
})
export class VoucherGenModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-gen/voucher-gen.module.ts